module.exports = __webpack_public_path__ + "static/media/login-prm-pic3-en.abd02cd8.jpg";